const unescaped = new Map([
  ['&amp;', '&'],
  ['&#38;', '&'],
  ['&lt;', '<'],
  ['&#60;', '<'],
  ['&gt;', '>'],
  ['&#62;', '>'],
  ['&apos;', "'"],
  ['&#39;', "'"],
  ['&quot;', '"'],
  ['&#34;', '"']
]);
const regExp = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34);/g;

function unescapeHTML(str: string) {
  return str?.replace(regExp, function (m) {
    return unescaped.get(m) || m;
  });
}

export default unescapeHTML;